import {
  faFileArchive,
  faFileAudio,
  faFileImage,
  faFileVideo,
  faFilePdf,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFileCode,
} from '@fortawesome/pro-solid-svg-icons'
import { MultimediaTypes } from 'enum/multimediaTypes.enum'
import { IAllowedFile } from 'models/allowedFiles.model'

export const commmonAllowedFiles: IAllowedFile[] = [
  { extension: 'zip,rar', icon: faFileArchive },
  { extension: 'mp3,wav', icon: faFileAudio },
  { extension: 'jpg,jpeg,png,gif,bmp', icon: faFileImage },
  { extension: 'webm,mp4', icon: faFileVideo },
  { extension: 'pdf', icon: faFilePdf },
  { extension: 'doc,docx,odf,docm,dotx,dotm', icon: faFileWord },
  {
    extension: 'ppt,pptx,key,odp,pptm,potx,potm,ppam,ppsx,sldx,sldm,thmx',
    icon: faFilePowerpoint,
  },
  {
    extension: 'xls,xlsx,numbers,ods,xlsm,xltx,xltm,xlsb,xlam',
    icon: faFileExcel,
  },
  { extension: 'txt,epub,mobi,mpp,xml', icon: faFileCode },
]

export const multimediaBlockIframeAllowedFiles: IAllowedFile[] = [
  {
    extension: 'mp4,webm',
    icon: faFileVideo,
    type: MultimediaTypes.video,
  },
  {
    extension: 'jpg,jpeg,png,gif,bmp',
    icon: faFileImage,
    type: MultimediaTypes.image,
  },
  { extension: 'pdf', icon: faFilePdf, type: MultimediaTypes.pdf },
  {
    extension: 'ppt,pptx,key,odp,pptm,potx,potm,ppam,ppsx,sldx,sldm,thmx',
    icon: faFilePowerpoint,
    type: MultimediaTypes.ppt,
  },
]
